export default function BaseUrl(){
    const url = {};
    // url.base = "http://127.0.0.1:8000/api";
    // url.public = "http://127.0.0.1:8000/";
    // url.image = "http://127.0.0.1:8000/storage";

    url.base = "https://k2mreports-api.distriforce.report/api";
    url.public = "https://k2mreports-api.distriforce.report/";
    url.image = "https://k2mreports-api.distriforce.report/storage";
    return url;
}